<div class="d-flex udex-my-20">
  <h6 data-cy="billing-information__title" class="navigation__medium--l align-self-center">
    {{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.title' | cxTranslate }}
  </h6>
  <dcp-icon-button-tooltip [placement]="'Top'" [openOnClick]="true" accessibleName="billingInformationTooltip">
    <div class="billing-information__tooltip">
      <div class="heading__medium--xxxs udex-mb-8">
        {{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.title' | cxTranslate }}
      </div>
      <div class="body--s">
        <div class="udex-mb-20">
          {{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.firstLine' | cxTranslate }}
        </div>
        <div>{{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.secondLine' | cxTranslate }}</div>
      </div>
    </div>
  </dcp-icon-button-tooltip>
</div>
<ng-container *ngIf="invoiceContacts">
  <dcp-technical-contacts
    data-cy="billing-contacts"
    (selectedContact)="onContactSelect($event)"
    [newContactRole]="contactRole"
    [contacts]="invoiceContacts"
    [initialSelectedContact]="initialSelectedInvoiceContact"
    [addExternalContacts]="true"
    actionButtonAlternativeText="checkout.digitalNativeCheckout.createNew.create"
    createNewContactText="checkout.digitalNativeCheckout.createNew.billingContact"
    editContactText="checkout.digitalNativeCheckout.edit.billingContact"
    contactType="checkout.digitalNativeCheckout.billingContact"
    [header]="'checkout.digitalNativeCheckout.paymentType.billingInformation.billingContact' | cxTranslate">
  </dcp-technical-contacts>
</ng-container>
<ng-container *ngIf="invoiceAddresses">
  <div class="mt-4">
    <dcp-company-addresses
      data-cy="billing-information-address"
      (selectedAddress)="onAddressSelect($event)"
      [showEditButton]="true"
      [showCompanyExtraData]="true"
      [editAddressModalHeaderText]="'checkout.digitalNativeCheckout.editAddress.header' | cxTranslate"
      [editAddressModalSubmitButtonText]="'checkout.digitalNativeCheckout.editAddress.submitButton' | cxTranslate"
      [addresses]="invoiceAddresses"
      [initialSelectedShipToAddress]="initialSelectedInvoiceAddress"
      [addAddressModalLinkText]="'checkout.digitalNativeCheckout.createNewAddresss' | cxTranslate"
      [addAddressModalHeaderText]="'checkout.digitalNativeCheckout.newBillingAddress.heading' | cxTranslate"
      [addAddressModalCreateButtonText]="'checkout.digitalNativeCheckout.newBillingAddress.submit' | cxTranslate"
      [addAddressModalUsageType]="usageType"
      [actionButtonAlternativeText]="'checkout.digitalNativeCheckout.createNew.create' | cxTranslate"
      header="checkout.digitalNativeCheckout.paymentType.billingInformation.billingAddress">
    </dcp-company-addresses>
  </div>
</ng-container>
<ng-template #tooltipContent data-cy="tooltip-content">
  <div
    class="ds-font--bold mb-4">{{
      'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.title' |
        cxTranslate
    }}
  </div>
  <div
    class="mb-4">{{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.firstLine' | cxTranslate }}
  </div>
  <div>{{ 'checkout.digitalNativeCheckout.paymentType.billingInformation.tooltipContent.secondLine' | cxTranslate }}</div>
</ng-template>
